var checkMax = 0
window.loadedProductOptions  = setInterval(function () {
  if (window.boostPFS !== undefined 
      && window.boostPFS.filter.isRendered) {

        window.productOptions = {
          selectors : {
            'productCards'          : '.product_card[data-product-handle]',
            'quickPanelTggle'       : 'button.btn-quick_add',
            'quickPanelATC'         : '.quick_panel_btn-atc',
            'quickPanelMobile'      : '#pdp_quickpanel_mobile',
            'variantInputs'         : '[qp-variant-select]',
          },
      
          messages: {
            'waiting'      : 'Loading...',
            'default'      : 'Oops! An error has occurred, refresh the page and try again.',
            'productError' : 'Oops! An error has occurred, if error persists please contact store owner.',
            'atc'          : {
              'ok'       : 'Add To Cart',
              'oos'      : 'Out of Stock - Notify Me',
              'error'    : 'Unavailable',
              'preorder' : 'PreOrder - Ships'
            }
          },
      
          /**
           * @summary Initializes the product variants functionality
           * 
           * @description Waits on doc ready to init
           *
           * @return  {void}
           */
          init: function () {
            var self = this;
            self.products = $(self.selectors.productCards);
      
            // No products found
            if (!self.products.length) {
              console.log('products not found');
              return;
            }
      
            self.addEventListeners();
          },
      
          /**
           * @summary Adds event listeners
           * 
           * @description Creates the event listeners
           * used throughout this class.
           *
           * @return  {void}
           */
          addEventListeners: function () {
            var self = this;

            $('.pdp_quickpanel_mobile_close').click(function (e) { 
              e.preventDefault();
              $('#pdp_quickpanel_mobile').modal('hide');
            });
            
            // QuickPanel Open
            $(document).on('click', self.selectors.quickPanelTggle, function () {
              var productHandle = $(this).attr('data-product-handle');
              var quickPanel    = $(`.quick_add_panel[data-product-handle="${productHandle}"]`);

              if( !quickPanel.hasClass('loaded') )
                self.renderQuickPanel(productHandle)

              if( window.innerWidth < 767) {
                if( quickPanel.is(':visible') ) {
                  quickPanel.modal('hide');
                } else {
                  quickPanel.modal('show').css('padding-right', '0');
                }
              } else {
                quickPanel.toggle();
              }
            });
      
            // Close out any open modals if we resize
            $(window).resize(function () {
              $('.quick_add_panel').each(function() {
                var quickPanel = $(this);
                if( window.innerWidth < 767) {
                  if( quickPanel.is(':visible') ) {
                    quickPanel.hasClass('show') ? quickPanel.modal('hide') : quickPanel.hide();
                  }
                }
              })
            });
      
            // Input Changes
            $(document).on('change', self.selectors.variantInputs, function (e) {
              e.preventDefault();
              var input         = $(this);
              var rootId        = input.attr('data-root-id');

              // Update selected color label
              if( input.attr('data-type') === 'color' ) {
                var productId      = $(this).attr('data-product-id');
                var variantWrapper = $(`.variant_options[data-root-id="${rootId}"]`);

                variantWrapper.find('p.selected_variant_type').text(input.val());
                variantWrapper.find('.toggle_select').each(function() {
                  $(this).attr('data-product-id') === productId ? ($(this).show(), $(this).find('label.active')) : $(this).hide();
                })
              }
              
              // Update prices
              self.updateAtc(rootId);
            });

            // Clear out modal data just in case
            $('#notifyMeModal').on('hide.bs.modal', function () {
              $('#notify_me_variant_id').val('');
              $('#notify_me_product_id').val('');
            })
      
            // ATC
            $(document).on('click', self.selectors.quickPanelATC, function (e) {
              e.preventDefault();
      
              var atcButton = $(this);
              var variantId = atcButton.attr('data-product-id');
      
              if ( atcButton.hasClass('notify_me') ) {

                $('#notify_me_variant_id').val(atcButton.attr('data-product-id'));
                $('#notify_me_product_id').val(atcButton.attr('data-root-id'));
                $('#notifyMeModal').modal('show');
                
                } else {
      
                var extraData = {};
      
                if( atcButton.attr('data-preorder') !== undefined )
                  extraData['_preorderDate'] = atcButton.attr('data-preorder');
        
                CartJS.addItem(variantId, 1, extraData, {
                  'success': function () {
                    $('#offcanvas_cart').toggleClass('show');
                    $('.screen-overlay').toggleClass('show');
                    $('body').toggleClass('offcanvas-active');
                  },
                  'error': function () {
                    alert('There was a problem adding to the cart!')
                  }
                });
              }
            });
          },
      
          /**
           * @summary Render QuickPanel
           * 
           * @description Initializes the processes required
           * to build the quick panel elements. It calls
           * the render section URL to build it.
           *
           * @return  {void}
           */
          renderQuickPanel: function (productHandle) {
            var self         = this;
            var variantPanel = $(`.variant_options[data-product-handle="${productHandle}"]`);
            var miliseconds  = new Date().getMilliseconds();

            self.showMessage(productHandle, self.messages.waiting);
            
            $.ajax({
              url      : `/products/${productHandle}?view=ajax-options&cache=${miliseconds}`,
              success  : function(resHTML) {
                var variantsHtml = $($.parseHTML(resHTML)).find('#product');
                var atcButton    = variantsHtml.find('button').detach();
                
                variantPanel.html(variantsHtml.html())
                            .after(atcButton)
                            .parent()
                            .parent()
                            .addClass('loaded');

                self.updateAtc(variantPanel.attr('data-root-id'));
              },
    
              // Default error handling
              error : function() {
                self.showMessage(productHandle, self.messages.default);
                return;
              }
            });
          },
          
          /**
           * @summary Shows a message
           * 
           * @description Shows a message where the panel
           * normally goes.
           *
           * @return  {void}
           */
          showMessage: function (productHandle, message) {
            $(`.variant_options[data-product-handle="${productHandle}"]`).html('').append(`<p>${message ?? ''}</p>`);
          },
      
          /**
           * @summary Updates the add to cart button
           * 
           * @description Called to update the atc
           * based on stock, price and availability
           *
           * @return  {void}
           */
          updateAtc: function (rootId) {
            var self          = this;
            var activeProduct = $(`.quick_add_panel[data-root-id="${rootId}"] .variant_select_wrapper:visible label.active input`).last();
            var productId     = activeProduct.attr('data-product-id');
            var atcButton     = $(`button.quick_panel_btn-atc[data-root-id="${rootId}"]`);

            if( activeProduct.length ) {
              atcButton.removeAttr('data-preorder')
                       .removeClass('notify_me')
                       .attr('data-root-id', rootId)
                       .attr('data-product-id', productId);
  
              // Pre Order
              if (activeProduct.attr('data-preorder') !== undefined) {
                atcButton.attr('data-preorder', activeProduct.attr('data-preorder'))
                         .text(`${self.messages.atc.preorder} ${activeProduct.attr('data-preorder')}`);
                return;
              }
        
              // OOS - Notify
              if (activeProduct.attr('data-available') === 'false') {
                atcButton.addClass('notify_me')
                         .text(self.messages.atc.oos);
                return;
              }
              
              // Default behavior
              atcButton.html(`${self.messages.atc.ok} - <span class="product_card_price_wrapper">${activeProduct.attr('data-price')}</span>`);
            }
          },
        };

        // Initialize product options
        productOptions.init();
        clearInterval(window.loadedProductOptions);
      }

  if (checkMax >= 15)
    (console.log('Error! - Could not load product options.'), clearInterval(window.loadedProductOptions));
  
  checkMax++;
}, 300);


